import { render } from "./component-qyry.vue?vue&type=template&id=2194041f"
import script from "./component-qyry.vue?vue&type=script&lang=js"
export * from "./component-qyry.vue?vue&type=script&lang=js"

import "./component-qyry.vue?vue&type=style&index=0&id=2194041f&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__